import React from 'react';

import {
	LOG,
	SHOW_FEEDBACK,
	HIDE_FEEDBACK,
	SET_ITEMS,
	SET_ITEMS_AAXML,
	SET_ITEMS_KEYS,
	GO_TO_PREVIOUS_ITEM,
	GO_TO_NEXT_ITEM,
	GO_TO_ITEM,
	RECOVER_SAVED_STATE,
	SHOW_RESULTS,
	RESTART_EXERCISE,
	SET_INTERACTION,
	SET_VERSION,
	SET_TEST_MODE,
	SET_TEST_SENT,
	START_RECORDING,
	STOP_RECORDING,
	SET_EX_CONTAINER,
	SET_EXERCISE_READY,
	SET_BASE_PATH,
	SET_ITEM_MARKED_TEXT,
	ANSWER_QUESTION,
	SET_AUDIO_PREFIX,
	SET_AUDIO_ENABLED,
	DISABLE_RECORDING
} from './types';
import { getUploadUrls, saveAudio } from './recording_actions';

export const log = (x) => {
	console.log(x);
	return ({
		type: LOG,
		payload: (
			<div>{x}</div>
		)
	});
};

export const recoverSavedState = (state) => ({ type: RECOVER_SAVED_STATE, payload: state });
export const answerQuestion = () => ({ type: ANSWER_QUESTION });
export const showResults = () => ({ type: SHOW_RESULTS });
export const restartExercise = () => ({ type: RESTART_EXERCISE });
export const setInteraction = (interaction) => ({ type: SET_INTERACTION, payload: interaction });
export const setVersion = (version) => ({ type: SET_VERSION, payload: version });
export const setTestMode = (testMode) => ({ type: SET_TEST_MODE, payload: testMode });
export const setExContainer = (exContainer) => ({ type: SET_EX_CONTAINER, payload: exContainer });
export const goToPreviousItem = () => ({ type: GO_TO_PREVIOUS_ITEM });
export const goToNextItem = () => ({ type: GO_TO_NEXT_ITEM });
export const goToItem = (index) => ({ type: GO_TO_ITEM, payload: index });
export const setBasePath = (basePath) => ({ type: SET_BASE_PATH, payload: basePath });
export const setItemMarkedText = (markedText) => ({ type: SET_ITEM_MARKED_TEXT, payload: markedText });
export const setAudioEnabled = (enabled) => ({ type: SET_AUDIO_ENABLED, payload: enabled });
export const setAudioPrefix = (audioPrefix) => ({ type: SET_AUDIO_PREFIX, payload: audioPrefix });

export const showFeedback = (type, loading, messageId, fromItem, errorCode) => async (dispatch, getState) => {
	dispatch({
		type: SHOW_FEEDBACK,
		payload: {
			index: fromItem === undefined ? getState().exercise.currentItem : fromItem,
			type,
			loading,
			messageId,
			errorCode
		}
	});
};

export const setItems = (items) => async (dispatch, getState) => {
	items.forEach((e, i) => e.itemIndex = i); // necesario para el save state (usado en updateInteraction)
	dispatch({ type: SET_ITEMS, payload: items });
};

export const setTestSent = () => async (dispatch, getState) => {
	const { loader: { interaction }, exercise: { wordsRecognised, totalWords } } = getState();
	if (interaction) interaction.setScore(wordsRecognised, totalWords);
	dispatch({ type: SET_TEST_SENT });
};

export const hideFeedback = () => async (dispatch, getState) => dispatch({
	type: HIDE_FEEDBACK,
	payload: { index: getState().exercise.currentItem }
});

export const processItems = () => async (dispatch, getState) => {
	// console.log('actions/index.js:processItems()');
	const { interaction } = getState().loader;
	const { items } = getState().exercise;

	dispatch({ type: SET_ITEMS, payload: items });

	const itemsAAXML = items.map(item => `<AARequest>
	<analysis analysisType="ReadingFluency"><text>${item._}</text></analysis>
	<analysis analysisType="SpeakingFluency"><text>${item._}</text></analysis>
	</AARequest>`);

	dispatch({
		type: SET_ITEMS_AAXML,
		payload: itemsAAXML
	});

	if (interaction && !window.concurrentUser) {
		const itemsKeys = items.map((item, i) => {
			const { unitId } = window.NL_CONFIG;
			const resourceId = window.API._currentScoId; // eslint-disable-line no-underscore-dangle
			const interactionIndex = interaction.index;
			if (unitId !== undefined && resourceId !== undefined && interactionIndex !== undefined) {
				return `${unitId}/${resourceId}/${interactionIndex}/${i}`;
			}
			return undefined;
		});

		dispatch({
			type: SET_ITEMS_KEYS,
			payload: itemsKeys
		});
	}

	dispatch({ type: SET_EXERCISE_READY });
};

export const setInteractionInterface = (interactionInterface) => async (dispatch, getState) => {
	const interaction = window.nl_loader.getNextInteraction();

	if (interaction) {
		interaction.setExerciseInteractionInterface(interactionInterface);
		dispatch(setInteraction(interaction));
	}
};

export const recordingStarted = () => async (dispatch, getState) => {
	// console.log('actions:recordingStarted()');
	// dispatch(log('actions:recordingStarted()'));
	dispatch({ type: START_RECORDING });
	dispatch(showFeedback('recording'));
	dispatch(getUploadUrls());
};

export const recordingStopped = (data) => async (dispatch, getState) => {
	// console.log('actions:recordingStopped()');
	// dispatch(log('actions:recordingStopped()'));
	dispatch({ type: STOP_RECORDING });
	dispatch({ type: DISABLE_RECORDING });
	dispatch(showFeedback('analysis'));
	dispatch(saveAudio(data));
};

export * from './recording_actions';
